export const fallbackImage = 'data:image/png;base64,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';

export const rupeeCurrency = "₹ ";

export const states = ["Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttarakhand",
    "Uttar Pradesh",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli",
    "Daman and Diu",
    "Delhi",
    "Lakshadweep",
    "Puducherry"];

export const DemoMetadata = {
    AboutUs: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    CODInstruction: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    CallEnabled: true,
    DeliveryCharges: "250",
    DeliveryInstruction: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    Email: "Test@gmail.com",
    MessageEnabled: true,
    MinimumCheckout: "520",
    PaymentPolicy: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    PhoneNo: "1234567890",
    PickupAddress: "Hyderabad, Telangana",
    PickupInstruction: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    PrivacyPolicy: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    ReturnAndRefundPolicy: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    ShippingPolicy: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    TermsAndConditions: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    WhatsappEnabled: true,
    codEnabled: true,
    deliveryEnabled: true,
    emailEnabled: true,
    filterSelection: "all",
    isLive: true,
    pickupEnabled: true,
    selectedItems: { E2UGNZf4o_tLQAQvWQDV: true },
    title: "Demo",
    theme: 0,
    gstEnabled: false,
    Tax: '10',
    design: 'whiteMinimal',
    font: 0,
    color: 0,
    alignment: 1,
    trendingItems: {
        '3p_AG9hSk_tLQAQvWQDV': true,
        'MMjXs6Si3_tLQAQvWQDV': true
    },
    newArrivalsItems: {
        'E2UGNZf4o_tLQAQvWQDV': true,
        'hfPxR_DGj_tLQAQvWQDV': true
    },
    timings: {}
};

export const DemoItems = [{ "id": "3p_AG9hSk_tLQAQvWQDV", "name": "Product 1", "code": null, "category": "Category 1", "quantity": 2, "price": 24000, "cgst": null, "sgst": null, "igst": null, "unit": "Phone", "tax": null, "barcode": null, "metadata": "{\"description\":\"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\", \"imageUri\":\"file:///storage/emulated/0/Pictures/3p_AG9hSk_tLQAQvWQDV\",\"downloadImageUri\":\"https://firebasestorage.googleapis.com/v0/b/naavoinc.appspot.com/o/tLQAQvWQDV%2Fimages%2Fitems%2F3p_AG9hSk_tLQAQvWQDV?alt=media&token=b30200fe-6a6a-4ac5-82a1-ab824c7d57a0\"}"}, { "id": "E2UGNZf4o_tLQAQvWQDV", "name": "Product 2", "code": null, "category": "Category 2", "quantity": 83, "price": 42, "cgst": null, "sgst": null, "igst": null, "unit": "Bottles", "tax": null, "barcode": null, "metadata": null }, { "id": "hfPxR_DGj_tLQAQvWQDV", "name": "Product 3", "code": null, "category": "Category 5", "quantity": 39, "price": 42, "cgst": null, "sgst": null, "igst": null, "unit": "Kilos", "tax": null, "barcode": null, "metadata": "{\"imageUri\":\"file:///storage/emulated/0/Pictures/3p_AG9hSk_tLQAQvWQDV\",\"downloadImageUri\":\"https://firebasestorage.googleapis.com/v0/b/naavoinc.appspot.com/o/tLQAQvWQDV%2Fimages%2Fitems%2F3p_AG9hSk_tLQAQvWQDV?alt=media&token=b30200fe-6a6a-4ac5-82a1-ab824c7d57a0\"}" }, { "id": "vOJ7uoHJj_tLQAQvWQDV", "name": "Product 4", "code": null, "category": "Category 2", "quantity": 950, "price": 42, "cgst": null, "sgst": null, "igst": null, "unit": "Kilos", "tax": null, "barcode": null, "metadata": null }, { "id": "n3iT4o9SQ_tLQAQvWQDV", "name": "Product 5", "code": null, "category": "Category 3", "quantity": 0, "price": 45, "cgst": 2, "sgst": 2, "igst": 2, "unit": "Kgs", "tax": null, "barcode": "031604027506", "metadata": "{\"imageUri\":\"file:///storage/emulated/0/Pictures/3p_AG9hSk_tLQAQvWQDV\",\"downloadImageUri\":\"https://firebasestorage.googleapis.com/v0/b/naavoinc.appspot.com/o/tLQAQvWQDV%2Fimages%2Fitems%2F3p_AG9hSk_tLQAQvWQDV?alt=media&token=b30200fe-6a6a-4ac5-82a1-ab824c7d57a0\"}" }, { "id": "MMjXs6Si3_tLQAQvWQDV", "name": "Product 6", "code": null, "category": "Category 4", "quantity": 858.6, "price": 550, "cgst": 2, "sgst": 2, "igst": 2, "unit": "Piece", "tax": null, "barcode": null, "metadata": "{\"imageUri\":\"file:///storage/emulated/0/Pictures/3p_AG9hSk_tLQAQvWQDV\",\"downloadImageUri\":\"https://firebasestorage.googleapis.com/v0/b/naavoinc.appspot.com/o/tLQAQvWQDV%2Fimages%2Fitems%2F3p_AG9hSk_tLQAQvWQDV?alt=media&token=b30200fe-6a6a-4ac5-82a1-ab824c7d57a0\"}" }, { "id": "crxlkIN5l_tLQAQvWQDV", "name": "Product 7", "code": null, "category": null, "quantity": 2250, "price": 25, "cgst": 2, "sgst": 2, "igst": 2, "unit": "Boxes", "tax": null, "barcode": "036000291452", "metadata": "{\"imageUri\":\"file:///storage/emulated/0/Pictures/3p_AG9hSk_tLQAQvWQDV\",\"downloadImageUri\":\"https://firebasestorage.googleapis.com/v0/b/naavoinc.appspot.com/o/tLQAQvWQDV%2Fimages%2Fitems%2F3p_AG9hSk_tLQAQvWQDV?alt=media&token=b30200fe-6a6a-4ac5-82a1-ab824c7d57a0\"}" }];

// Sample Data
const BakeryItems = [
    {
      "id": "3p_AG9hSk_tLQAQvWQDV",
      "name": "Bread",
      "code": null,
      "category": "Breads",
      "quantity": 2,
      "price": 24,
      "cgst": null,
      "sgst": null,
      "igst": null,
      "unit": "Packs",
      "tax": null,
      "barcode": null,
      "metadata": `{\"description\":\"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\", \"imageUri\":\"file:///storage/emulated/0/Pictures/3p_AG9hSk_tLQAQvWQDV\",\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/bakery/1.jpg'}\"}`
    },
    {
      "id": "E2UGNZf4o_tLQAQvWQDV",
      "name": "Chocolate Cake",
      "code": null,
      "category": "Cakes",
      "quantity": 83,
      "price": 42,
      "cgst": null,
      "sgst": null,
      "igst": null,
      "unit": "Kgs",
      "tax": null,
      "barcode": null,
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/bakery/2.jpg'}\"}`
    },
    {
      "id": "hfPxR_DGj_tLQAQvWQDV",
      "name": "Chocolate Mousse",
      "code": null,
      "category": "Cakes",
      "quantity": 39,
      "price": 62,
      "cgst": null,
      "sgst": null,
      "igst": null,
      "unit": "Kgs",
      "tax": null,
      "barcode": null,
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/bakery/3.jpg'}\"}`
    },
    {
      "id": "vOJ7uoHJj_tLQAQvWQDV",
      "name": "Chocolate Sliced Cake",
      "code": null,
      "category": "Cakes",
      "quantity": 950,
      "price": 82,
      "cgst": null,
      "sgst": null,
      "igst": null,
      "unit": "Kgs",
      "tax": null,
      "barcode": null,
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/bakery/4.jpg'}\"}`
    },
    {
      "id": "n3iT4o9SQ_tLQAQvWQDV",
      "name": "Cinnamon Roll",
      "code": null,
      "category": "Cakes",
      "quantity": 0,
      "price": 45,
      "cgst": 2,
      "sgst": 2,
      "igst": 2,
      "unit": "Kgs",
      "tax": null,
      "barcode": "031604027506",
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/bakery/5.jpg'}\"}`
    },
    {
      "id": "MMjXs6Si3_tLQAQvWQDV",
      "name": "Croissants",
      "code": null,
      "category": "Breads",
      "quantity": 858.6,
      "price": 550,
      "cgst": 2,
      "sgst": 2,
      "igst": 2,
      "unit": "Piece",
      "tax": null,
      "barcode": null,
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/bakery/6.jpg'}\"}`
    },
    {
      "id": "crxlkIN5l_tLQAQvWQDV",
      "name": "Cup Cakes",
      "code": null,
      "category": "Cakes",
      "quantity": 2250,
      "price": 25,
      "cgst": 2,
      "sgst": 2,
      "igst": 2,
      "unit": "Boxes",
      "tax": null,
      "barcode": "036000291452",
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/bakery/7.jpg'}\"}`
    },
      {
      "id": "crxlkIN5l_tLQAQvWQDV",
      "name": "Flower Cake",
      "code": null,
      "category": "Cakes",
      "quantity": 2250,
      "price": 55,
      "cgst": 2,
      "sgst": 2,
      "igst": 2,
      "unit": "Kgs",
      "tax": null,
      "barcode": "036000291452",
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/bakery/8.jpg'}\"}`
    },
     {
      "id": "crxlkIN5l_tLQAQvWQDV",
      "name": "Macaroons",
      "code": null,
      "category": "Biscuits",
      "quantity": 2250,
      "price": 75,
      "cgst": 2,
      "sgst": 2,
      "igst": 2,
      "unit": "Kgs",
      "tax": null,
      "barcode": "036000291452",
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/bakery/9.jpg'}\"}`
    },
    {
      "id": "crxlkIN5l_tLQAQvWQDV",
      "name": "Pexels Tijana Drndarski",
      "code": null,
      "category": "Donuts",
      "quantity": 2250,
      "price": 15,
      "cgst": 2,
      "sgst": 2,
      "igst": 2,
      "unit": "Kgs",
      "tax": null,
      "barcode": "036000291452",
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/bakery/10.jpg'}\"}`
    }
];

const ElectronicsItems = [
    {
      "id": "3p_AG9hSk_tLQAQvWQDV",
      "name": "Apple Watch",
      "code": null,
      "category": "Watches",
      "quantity": 2,
      "price": 24,
      "cgst": null,
      "sgst": null,
      "igst": null,
      "unit": "Piece",
      "tax": null,
      "barcode": null,
      "metadata": `{\"description\":\"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\", \"imageUri\":\"file:///storage/emulated/0/Pictures/3p_AG9hSk_tLQAQvWQDV\",\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/electronics/1.jpg'}\"}`
    },
    {
      "id": "E2UGNZf4o_tLQAQvWQDV",
      "name": "Camera",
      "code": null,
      "category": "Camera & Recorders",
      "quantity": 83,
      "price": 42,
      "cgst": null,
      "sgst": null,
      "igst": null,
      "unit": "Piece",
      "tax": null,
      "barcode": null,
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/electronics/2.jpg'}\"}`
    },
    {
      "id": "hfPxR_DGj_tLQAQvWQDV",
      "name": "Drone",
      "code": null,
      "category": "Camera & Recorders",
      "quantity": 39,
      "price": 62,
      "cgst": null,
      "sgst": null,
      "igst": null,
      "unit": "Piece",
      "tax": null,
      "barcode": null,
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/electronics/3.jpg'}\"}`
    },
    {
      "id": "vOJ7uoHJj_tLQAQvWQDV",
      "name": "Food Scale",
      "code": null,
      "category": "Accessories",
      "quantity": 950,
      "price": 82,
      "cgst": null,
      "sgst": null,
      "igst": null,
      "unit": "Piece",
      "tax": null,
      "barcode": null,
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/electronics/4.jpg'}\"}`
    },
    {
      "id": "n3iT4o9SQ_tLQAQvWQDV",
      "name": "Headsets",
      "code": null,
      "category": "Headsets & Speakers",
      "quantity": 0,
      "price": 45,
      "cgst": 2,
      "sgst": 2,
      "igst": 2,
      "unit": "Piece",
      "tax": null,
      "barcode": "031604027506",
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/electronics/5.jpg'}\"}`
    },
    {
      "id": "MMjXs6Si3_tLQAQvWQDV",
      "name": "IPhone",
      "code": null,
      "category": "Phones",
      "quantity": 858.6,
      "price": 550,
      "cgst": 2,
      "sgst": 2,
      "igst": 2,
      "unit": "Piece",
      "tax": null,
      "barcode": null,
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/electronics/6.jpg'}\"}`
    },
    {
      "id": "crxlkIN5l_tLQAQvWQDV",
      "name": "Joystick",
      "code": null,
      "category": "Computer Accessories",
      "quantity": 2250,
      "price": 25,
      "cgst": 2,
      "sgst": 2,
      "igst": 2,
      "unit": "Piece",
      "tax": null,
      "barcode": "036000291452",
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/electronics/7.jpg'}\"}`
    },
      {
      "id": "crxlkIN5l_tLQAQvWQDV",
      "name": "Mouse",
      "code": null,
      "category": "Computer Accessories",
      "quantity": 2250,
      "price": 55,
      "cgst": 2,
      "sgst": 2,
      "igst": 2,
      "unit": "Piece",
      "tax": null,
      "barcode": "036000291452",
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/electronics/8.jpg'}\"}`
    },
     {
      "id": "crxlkIN5l_tLQAQvWQDV",
      "name": "Speakers",
      "code": null,
      "category": "Headsets & Speakers",
      "quantity": 2250,
      "price": 75,
      "cgst": 2,
      "sgst": 2,
      "igst": 2,
      "unit": "Piece",
      "tax": null,
      "barcode": "036000291452",
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/electronics/9.jpg'}\"}`
    },
    {
      "id": "crxlkIN5l_tLQAQvWQDV",
      "name": "Telephones",
      "code": null,
      "category": "Phones",
      "quantity": 2250,
      "price": 15,
      "cgst": 2,
      "sgst": 2,
      "igst": 2,
      "unit": "Piece",
      "tax": null,
      "barcode": "036000291452",
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/electronics/10.jpg'}\"}`
    }
];

const GroceryItems = [
    {
      "id": "3p_AG9hSk_tLQAQvWQDV",
      "name": "Apple",
      "code": null,
      "category": "Fruits",
      "quantity": 2,
      "price": 24,
      "cgst": null,
      "sgst": null,
      "igst": null,
      "unit": "Piece",
      "tax": null,
      "barcode": null,
      "metadata": `{\"description\":\"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\", \"imageUri\":\"file:///storage/emulated/0/Pictures/3p_AG9hSk_tLQAQvWQDV\",\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/grocery/1.jpg'}\"}`
    },
    {
      "id": "E2UGNZf4o_tLQAQvWQDV",
      "name": "Blue Berries",
      "code": null,
      "category": "Fruits",
      "quantity": 83,
      "price": 42,
      "cgst": null,
      "sgst": null,
      "igst": null,
      "unit": "Kgs",
      "tax": null,
      "barcode": null,
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/grocery/2.jpg'}\"}`
    },
    {
      "id": "hfPxR_DGj_tLQAQvWQDV",
      "name": "Eggs",
      "code": null,
      "category": "Diary",
      "quantity": 39,
      "price": 62,
      "cgst": null,
      "sgst": null,
      "igst": null,
      "unit": "Kgs",
      "tax": null,
      "barcode": null,
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/grocery/3.jpg'}\"}`
    },
    {
      "id": "vOJ7uoHJj_tLQAQvWQDV",
      "name": "Onions",
      "code": null,
      "category": "Vegetables",
      "quantity": 950,
      "price": 82,
      "cgst": null,
      "sgst": null,
      "igst": null,
      "unit": "Kgs",
      "tax": null,
      "barcode": null,
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/grocery/4.jpg'}\"}`
    },
    {
      "id": "n3iT4o9SQ_tLQAQvWQDV",
      "name": "Papaya",
      "code": null,
      "category": "Fruits",
      "quantity": 0,
      "price": 45,
      "cgst": 2,
      "sgst": 2,
      "igst": 2,
      "unit": "Kgs",
      "tax": null,
      "barcode": "031604027506",
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/grocery/5.jpg'}\"}`
    },
    {
      "id": "MMjXs6Si3_tLQAQvWQDV",
      "name": "Peach",
      "code": null,
      "category": "Fruits",
      "quantity": 858.6,
      "price": 550,
      "cgst": 2,
      "sgst": 2,
      "igst": 2,
      "unit": "Kgs",
      "tax": null,
      "barcode": null,
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/grocery/6.jpg'}\"}`
    },
    {
      "id": "crxlkIN5l_tLQAQvWQDV",
      "name": "Pexels Marco-antonio-victorino",
      "code": null,
      "category": "Fruits",
      "quantity": 2250,
      "price": 25,
      "cgst": 2,
      "sgst": 2,
      "igst": 2,
      "unit": "Kgs",
      "tax": null,
      "barcode": "036000291452",
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/grocery/7.jpg'}\"}`
    },
      {
      "id": "crxlkIN5l_tLQAQvWQDV",
      "name": "Strawberry",
      "code": null,
      "category": "Fruits",
      "quantity": 2250,
      "price": 55,
      "cgst": 2,
      "sgst": 2,
      "igst": 2,
      "unit": "Kgs",
      "tax": null,
      "barcode": "036000291452",
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/grocery/8.jpg'}\"}`
    },
     {
      "id": "crxlkIN5l_tLQAQvWQDV",
      "name": "Tomatoes",
      "code": null,
      "category": "Vegetables",
      "quantity": 2250,
      "price": 75,
      "cgst": 2,
      "sgst": 2,
      "igst": 2,
      "unit": "Kgs",
      "tax": null,
      "barcode": "036000291452",
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/grocery/9.jpg'}\"}`
    },
    {
      "id": "crxlkIN5l_tLQAQvWQDV",
      "name": "Watermelon",
      "code": null,
      "category": "Fruits",
      "quantity": 2250,
      "price": 15,
      "cgst": 2,
      "sgst": 2,
      "igst": 2,
      "unit": "Kgs",
      "tax": null,
      "barcode": "036000291452",
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/grocery/10.jpg'}\"}`
    }
];

const FurnitureItems = [
    {
      "id": "3p_AG9hSk_tLQAQvWQDV",
      "name": "Bed",
      "code": null,
      "category": "Beds",
      "quantity": 2,
      "price": 24,
      "cgst": null,
      "sgst": null,
      "igst": null,
      "unit": "Piece",
      "tax": null,
      "barcode": null,
      "metadata": `{\"description\":\"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\", \"imageUri\":\"file:///storage/emulated/0/Pictures/3p_AG9hSk_tLQAQvWQDV\",\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/furniture/1.jpg'}\"}`
    },
    {
      "id": "E2UGNZf4o_tLQAQvWQDV",
      "name": "Chairs",
      "code": null,
      "category": "Chairs & Tables",
      "quantity": 83,
      "price": 42,
      "cgst": null,
      "sgst": null,
      "igst": null,
      "unit": "Piece",
      "tax": null,
      "barcode": null,
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/furniture/2.jpg'}\"}`
    },
    {
      "id": "hfPxR_DGj_tLQAQvWQDV",
      "name": "Crib",
      "code": null,
      "category": "Beds",
      "quantity": 39,
      "price": 62,
      "cgst": null,
      "sgst": null,
      "igst": null,
      "unit": "Piece",
      "tax": null,
      "barcode": null,
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/furniture/3.jpg'}\"}`
    },
    {
      "id": "vOJ7uoHJj_tLQAQvWQDV",
      "name": "Cushions",
      "code": null,
      "category": "Bedding",
      "quantity": 950,
      "price": 82,
      "cgst": null,
      "sgst": null,
      "igst": null,
      "unit": "Piece",
      "tax": null,
      "barcode": null,
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/furniture/4.jpg'}\"}`
    },
    {
      "id": "n3iT4o9SQ_tLQAQvWQDV",
      "name": "Dining Table",
      "code": null,
      "category": "Chairs & Tables",
      "quantity": 0,
      "price": 45,
      "cgst": 2,
      "sgst": 2,
      "igst": 2,
      "unit": "Piece",
      "tax": null,
      "barcode": "031604027506",
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/furniture/5.jpg'}\"}`
    },
    {
      "id": "MMjXs6Si3_tLQAQvWQDV",
      "name": "Hand Mirror",
      "code": null,
      "category": "Accessories",
      "quantity": 858.6,
      "price": 550,
      "cgst": 2,
      "sgst": 2,
      "igst": 2,
      "unit": "Piece",
      "tax": null,
      "barcode": null,
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/furniture/6.jpg'}\"}`
    },
    {
      "id": "crxlkIN5l_tLQAQvWQDV",
      "name": "Night Stand",
      "code": null,
      "category": "Chairs & Tables",
      "quantity": 2250,
      "price": 25,
      "cgst": 2,
      "sgst": 2,
      "igst": 2,
      "unit": "Piece",
      "tax": null,
      "barcode": "036000291452",
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/furniture/7.jpg'}\"}`
    },
      {
      "id": "crxlkIN5l_tLQAQvWQDV",
      "name": "Sofa",
      "code": null,
      "category": "Sofas",
      "quantity": 2250,
      "price": 55,
      "cgst": 2,
      "sgst": 2,
      "igst": 2,
      "unit": "Piece",
      "tax": null,
      "barcode": "036000291452",
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/furniture/8.jpg'}\"}`
    },
     {
      "id": "crxlkIN5l_tLQAQvWQDV",
      "name": "Stand Fan",
      "code": null,
      "category": "Fans & Airconditioners",
      "quantity": 2250,
      "price": 75,
      "cgst": 2,
      "sgst": 2,
      "igst": 2,
      "unit": "Piece",
      "tax": null,
      "barcode": "036000291452",
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/furniture/9.jpg'}\"}`
    },
    {
      "id": "crxlkIN5l_tLQAQvWQDV",
      "name": "White Couch",
      "code": null,
      "category": "Sofas",
      "quantity": 2250,
      "price": 15,
      "cgst": 2,
      "sgst": 2,
      "igst": 2,
      "unit": "Piece",
      "tax": null,
      "barcode": "036000291452",
      "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/furniture/10.jpg'}\"}`
    }
];

const ClothingItems = [
  {
    "id": "3p_AG9hSk_tLQAQvWQDV",
    "name": "Baby Shoes",
    "code": null,
    "category": "Kids",
    "quantity": 2,
    "price": 24,
    "cgst": null,
    "sgst": null,
    "igst": null,
    "unit": "Piece",
    "tax": null,
    "barcode": null,
    "metadata": `{\"description\":\"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\", \"imageUri\":\"file:///storage/emulated/0/Pictures/3p_AG9hSk_tLQAQvWQDV\",\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/clothes/1.jpg'}\"}`
  },
  {
    "id": "E2UGNZf4o_tLQAQvWQDV",
    "name": "Salwar Kameez",
    "code": null,
    "category": "Clothes",
    "quantity": 83,
    "price": 42,
    "cgst": null,
    "sgst": null,
    "igst": null,
    "unit": "Piece",
    "tax": null,
    "barcode": null,
    "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/clothes/2.jpg'}\"}`
  },
  {
    "id": "hfPxR_DGj_tLQAQvWQDV",
    "name": "Hat",
    "code": null,
    "category": "Accessories",
    "quantity": 39,
    "price": 62,
    "cgst": null,
    "sgst": null,
    "igst": null,
    "unit": "Piece",
    "tax": null,
    "barcode": null,
    "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/clothes/3.jpg'}\"}`
  },
  {
    "id": "vOJ7uoHJj_tLQAQvWQDV",
    "name": "Leather Shoes",
    "code": null,
    "category": "Shoes",
    "quantity": 950,
    "price": 82,
    "cgst": null,
    "sgst": null,
    "igst": null,
    "unit": "Piece",
    "tax": null,
    "barcode": null,
    "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/clothes/4.jpg'}\"}`
  },
  {
    "id": "n3iT4o9SQ_tLQAQvWQDV",
    "name": "Mittens",
    "code": null,
    "category": "Kids",
    "quantity": 0,
    "price": 45,
    "cgst": 2,
    "sgst": 2,
    "igst": 2,
    "unit": "Piece",
    "tax": null,
    "barcode": "031604027506",
    "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/clothes/5.jpg'}\"}`
  },
  {
    "id": "MMjXs6Si3_tLQAQvWQDV",
    "name": "Nike Shoes",
    "code": null,
    "category": "Shoes",
    "quantity": 858.6,
    "price": 550,
    "cgst": 2,
    "sgst": 2,
    "igst": 2,
    "unit": "Piece",
    "tax": null,
    "barcode": null,
    "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/clothes/6.jpg'}\"}`
  },
  {
    "id": "crxlkIN5l_tLQAQvWQDV",
    "name": "Saree",
    "code": null,
    "category": "Clothes",
    "quantity": 2250,
    "price": 25,
    "cgst": 2,
    "sgst": 2,
    "igst": 2,
    "unit": "Piece",
    "tax": null,
    "barcode": "036000291452",
    "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/clothes/7.jpg'}\"}`
  },
    {
    "id": "crxlkIN5l_tLQAQvWQDV",
    "name": "Skinny Jeans",
    "code": null,
    "category": "Clothes",
    "quantity": 2250,
    "price": 55,
    "cgst": 2,
    "sgst": 2,
    "igst": 2,
    "unit": "Piece",
    "tax": null,
    "barcode": "036000291452",
    "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/clothes/8.jpg'}\"}`
  },
   {
    "id": "crxlkIN5l_tLQAQvWQDV",
    "name": "Suit",
    "code": null,
    "category": "Clothes",
    "quantity": 2250,
    "price": 75,
    "cgst": 2,
    "sgst": 2,
    "igst": 2,
    "unit": "Piece",
    "tax": null,
    "barcode": "036000291452",
    "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/clothes/9.jpg'}\"}`
  },
  {
    "id": "crxlkIN5l_tLQAQvWQDV",
    "name": "Sun glasses",
    "code": null,
    "category": "Accessories",
    "quantity": 2250,
    "price": 15,
    "cgst": 2,
    "sgst": 2,
    "igst": 2,
    "unit": "Piece",
    "tax": null,
    "barcode": "036000291452",
    "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/clothes/10.jpg'}\"}`
  },
  {
    "id": "crxlkIN5l_tLQAQvWQDV",
    "name": "Sweater",
    "code": null,
    "category": "Clothes",
    "quantity": 2250,
    "price": 15,
    "cgst": 2,
    "sgst": 2,
    "igst": 2,
    "unit": "Piece",
    "tax": null,
    "barcode": "036000291452",
    "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/clothes/11.jpg'}\"}`
  },
  {
    "id": "crxlkIN5l_tLQAQvWQDV",
    "name": "T-Shirts",
    "code": null,
    "category": "Clothes",
    "quantity": 2250,
    "price": 15,
    "cgst": 2,
    "sgst": 2,
    "igst": 2,
    "unit": "Piece",
    "tax": null,
    "barcode": "036000291452",
    "metadata": `{\"downloadImageUri\":\"${process.env.PUBLIC_URL + '/clothes/12.jpg'}\"}`
  }
];

export function getSampleItems(sample: string) {
    if (sample == 'Bakery') {
      return BakeryItems;
    }

    if (sample == 'Electronics') {
      return ElectronicsItems;
    }

    if (sample == 'Grocery') {
      return GroceryItems;
    }

    if (sample == 'Clothing') {
      return ClothingItems;
    }

    return FurnitureItems;
}
